
    import './styles.scoped.css';
    export default {
  "root": "_root_mgnkh_3",
  "content": "_content_mgnkh_25",
  "content-no-paddings": "_content-no-paddings_mgnkh_25",
  "content-has-header": "_content-has-header_mgnkh_28",
  "header": "_header_mgnkh_32",
  "header-no-paddings": "_header-no-paddings_mgnkh_36",
  "footer": "_footer_mgnkh_40"
};
  